<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="4000"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-window v-model="step">
      <v-window-item :value="1">
        <dashboard />
      </v-window-item>
      <v-window-item :value="2">
        <article-review
          :title="editPaper.title"
          :abstract="editPaper.abstract"
          :keywords="editPaper.keywords"
          :download="editPaper.download"
          :status="editPaper.status"
          :comment="comments()"
          :review="review"
          :step="step"
          :paper="editPaper"
          @submit="step = 1"
          @setLoading="setLoading"
        />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import Dashboard from "@/components/molecules/paper/ReviewerDashboard.vue";
import ArticleReview from "@/components/molecules/paper/ArticleReview.vue";
export default {
  components: {
    dashboard: Dashboard,
    "article-review": ArticleReview,
  },
  data: () => ({
    step: 1,
    editItemId: "",
    loading: false,
  }),
  computed: {
    editPaper() {
      return this.$store.getters.paperById(this.editItemId) ?? {};
    },
    user() {
      return this.$store.getters.getUser;
    },
    review() {
      return this.editPaper?.state?.reviews[this.user.id];
    },
    snackbar() {
      return this.$store.state.snackbar.snackbar;
    },
  },
  methods: {
    comments() {
      if (this.editPaper.comments == null || this.editPaper.comments[0] == null)
        return null;
      return this.editPaper.comments[0].comment;
    },
    setLoading(status) {
      this.loading = status;
    },
  },
};
</script>
